import { setToken } from "@/utils/auth";

/**
 * 从 URL search 读取后台一键登录 token，写入本地并清理地址栏。
 * 链接格式：https://前端域名/?token=<jwt>#/
 * @returns {boolean} 是否消费了登录链接
 */
export function consumeTokenFromUrl() {
  if (typeof window === "undefined") return false;

  const url = new URL(window.location.href);
  let token = url.searchParams.get("token");

  // 兼容 token 落在 hash 查询里：#/?token=xxx
  if (!token && url.hash && url.hash.includes("?")) {
    const hashQuery = url.hash.slice(url.hash.indexOf("?") + 1);
    token = new URLSearchParams(hashQuery).get("token");
  }

  if (!token) return false;

  setToken(token);
  url.searchParams.delete("token");

  if (url.hash && url.hash.includes("?")) {
    const [hashPath, hashQuery = ""] = url.hash.split("?");
    const hashParams = new URLSearchParams(hashQuery);
    hashParams.delete("token");
    const nextHashQuery = hashParams.toString();
    url.hash = nextHashQuery ? `${hashPath}?${nextHashQuery}` : hashPath;
  }

  const search = url.searchParams.toString();
  const next = `${url.pathname}${search ? `?${search}` : ""}${url.hash || ""}`;
  window.history.replaceState(null, "", next || "/");
  return true;
}
